import type { VariationComponent } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck(
    props: VariationComponent
): IntegrityStatus {
    if (!props.id) return ["This VariationComponent is missing its ID"];

    return [];
}
